/**
 * v3.profileChange — BACKLOG-1675 (Bill 2026-10-02).
 *
 *   POST /v3/customers/{cif}/profile-change/preview — diff the saved person
 *        against live Core Director + the account waterfall plan.
 *   POST /v3/customers/{cif}/profile-change/apply   — CustMod (changed fields),
 *        AcctMod per confirmed account, 90-day notes on the CIF and each account.
 *
 * Both routes take the caller's bearer token; apply resolves the Core Director
 * operator from it (never from the body).
 */
import type {
  ProfileChangeApplyRequest,
  ProfileChangeApplyResponse,
  ProfileChangePreviewRequest,
  ProfileChangePreviewResponse,
  RequestOptions,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export class ProfileChangeApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public preview(
    cifId: string,
    body: ProfileChangePreviewRequest,
    opts?: RequestOptions,
  ): Promise<ProfileChangePreviewResponse> {
    return this.http.post<ProfileChangePreviewResponse>(
      `/v3/customers/${encodeURIComponent(cifId)}/profile-change/preview`,
      { ...opts, body },
    );
  }

  public apply(
    cifId: string,
    body: ProfileChangeApplyRequest,
    opts?: RequestOptions,
  ): Promise<ProfileChangeApplyResponse> {
    return this.http.post<ProfileChangeApplyResponse>(
      `/v3/customers/${encodeURIComponent(cifId)}/profile-change/apply`,
      { ...opts, body },
    );
  }
}
